import { render, staticRenderFns } from "./getCityplatformFee.vue?vue&type=template&id=4cf99fa0&scoped=true&"
import script from "./getCityplatformFee.vue?vue&type=script&lang=js&"
export * from "./getCityplatformFee.vue?vue&type=script&lang=js&"
import style0 from "./getCityplatformFee.vue?vue&type=style&index=0&id=4cf99fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf99fa0",
  null
  
)

export default component.exports